export enum EError {
	FORBIDDEN = 'forbidden', // 403
	PAGE_NOT_FOUND = 'page_not_found', // 404
	INTERNAL_SERVER_ERROR = 'internal_server_error', // 500
	BAD_GATEWAY = 'bad_gateway', // 502

	APP_ERROR = 'app_error',
}
